
// Test data for Level 1 Putting Training

export const puttingTests = [
  {
    id: "putts-plat",
    title: "Les putts à plat",
    description: "Sur le green d'entraînement ou sur le parcours, positionner 3 balles aux points G=6m, H=10m, I=12m et jouer successivement. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi",
    icon: "🎯"
  },
  {
    id: "putts-montee",
    title: "Les putts en montée",
    description: "Sur le green d'entraînement ou sur le parcours, positionner 3 balles en montée sur les points G1=6m, H1=10m, I1=12m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi",
    icon: "🎯"
  },
  {
    id: "putts-descente",
    title: "Les Putts en descente",
    description: "Sur le green d'entraînement ou sur le parcours, positionner 3 balles en descente aux points G2=6m, H2=10m, I2=12m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi",
    icon: "🎯"
  },
  {
    id: "putts-pente",
    title: "Les Putts en Pente gauche droite",
    description: "Sur le green d'entraînement ou sur le parcours, positionner 3 balles en pente gauche droite aux points G3=6m, H3=10m, I3=12m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi",
    icon: "🎯"
  },
  {
    id: "putts-pente-droite",
    title: "Les Putts en Pente droite gauche",
    description: "Sur le green d'entraînement ou sur le parcours, positionner 3 balles en pente droite gauche aux points G4=6m, H4=10m, I4=12m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi",
    icon: "🎯"
  }
];
